/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { compose } from 'recompose';
import {
    object, string,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import data from './ViewData';

const styles = (theme) => ({
    expressTitle: {
        fontWeight: 'bold',
    },
    snipeContent: {
        color: theme.palette.primary.main,
        margin: '0px 6px 15px',
        fontSize: '0.9em',
        [theme.breakpoints.up(600)]: {
            margin: '0px 6px 25px',
        },
    },
    noteCopy: {
        marginTop: '17px',
    },
});

const SnipeBanner = ({
    classes,
    snipeName,
}) => {
    if (!data || !data[snipeName]) {
        return null;
    }
    const { title, expressCopy, note } = data[snipeName];

    return (
        <div className={classes.snipeContent}>
            <div className={classes.expressTitle}>{title}</div>
            <div>{expressCopy}</div>
            <div className={classes.noteCopy}>
                <div><strong>Please note:</strong>{note} </div>
            </div>
        </div>
    );
};

SnipeBanner.propTypes = {
    classes: object.isRequired,
    snipeName: string.isRequired,
};
const enhance = compose(
    withStyles(styles),
);

export default enhance(SnipeBanner);
